import axios from "axios";
import { notification } from "antd";
import { getAccessToken } from "./tokenmanager";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_MTOENTERPRISE_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

//Automatically attach token to every request
apiClient.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    const buGuid = localStorage.getItem('BusinessUnitGuid');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    if (buGuid) {
      config.headers.BusinessUnitGuid = buGuid;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.error("Unauthorized or token expired");
      // optional: redirect or logout
    } else if (error.response?.status === 403) {
      notification.error({
        message: 'Access Denied',
        description: 'You do not have permission to perform this action.',
      });
      localStorage.removeItem('BusinessUnitGuid');
      localStorage.removeItem('BusinessUnitName');
      localStorage.removeItem('BusinessUnitCode');
      window.location.href = '/selectbusinessunit';
    } else if (error.response?.status >= 500) {
      notification.error({
        message: 'Server Error',
        description: 'An unexpected server error occurred.',
      });
    } else if (!error.response) {
      notification.error({
        message: 'Network Error',
        description: 'Failed to communicate with the server. Please check your connection.',
      });
    }

    return Promise.reject(error);
  }
);

export default apiClient;